// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"jp-z","slideIn":"kp-z"};